import React from "react";
import {
  Outlet,
  useParams,
  useNavigate
} from "react-router-dom";
import ClientContext from '../../providers/CurrentClientProvider'
import ClientService from '../../services/ClientService'
import AuthService from '../../services/AuthService'
import { syncAmplitudeIdentity } from '../../services/amplitudeIdentity'

export function shouldHydrateClientContext(currentClient, clientCode) {
  if (!clientCode) {
    return false
  }

  if (!currentClient || !currentClient.ClientCode) {
    return true
  }

  const routeMatchesCurrentClient = String(currentClient.ClientCode).toLowerCase() === String(clientCode).toLowerCase()
  if (routeMatchesCurrentClient && !currentClient?.Id && !currentClient?.id) {
    return true
  }

  return !routeMatchesCurrentClient
}

function ClientMiddleware() {
  const client_context = ClientContext.useClient();
  const {client_code} = useParams()
  const navigate = useNavigate()

  async function getClientByCode() {
      try {
        const _client = await ClientService.getClientByCode(client_code, 0, { rethrowError: true })

        if (!_client?.ClientCode) {
          client_context.setClient({})
          navigate('/', { replace: true })
          return
        }

        client_context.setClient(_client)
        syncAmplitudeIdentity({ user: AuthService.getLocalUser(), client: _client })
      } catch (error) {
        client_context.setClient({})

        // if 403, redirect to /
        if (error?.response?.status === 403) {
          navigate('/', { replace: true })
          return
        }

        if (error?.response?.status === 404) {
          navigate('/', { replace: true })
        }
      }
  }

  React.useEffect(() => {
    getClientByCode()
  }, [client_code])
  return <Outlet />
}

export default ClientMiddleware